<template>
    <div>
        <div class="top-notification"></div>
        <div data-collapse="medium" data-animation="default" data-duration="400" data-no-scroll="1" class="navbar1 active-nav1 navbar navbar-2 navbar-3 navbar-4 page-nav w-nav">
            <div class="nav1-wrap"><router-link v-bind:to="'/'" id="w-node-ca5062e76206-62e76204" class="brand w-nav-brand"><img src="../assets/images/rrp-logo.png" style="height: 60px;" alt=""></router-link>
                <div id="w-node-ca5062e76209-62e76204" class="nav1-menu-wrap">
                    <nav role="navigation" class="nav1-menu w-nav-menu" ref="mobileNav">
                        <router-link @click.native="closeMenu(false)" v-bind:to="'/'" class="nav-link w-nav-link">Home</router-link>
                        <router-link  v-if="loggedIn" @click.native="closeMenu(false)" v-bind:to="'/my-posts'" class="nav-link nav-hide w-nav-link">Manage Posts</router-link>
                        <router-link  @click.native="closeMenu(false)" v-bind:to="'/login'" v-if="!loggedIn" class="nav-link  nav-hide w-nav-link">Login / Register</router-link>
                        <span  v-if="loggedIn"><a  v-on:click="closeMenu(true)" class="nav-link nav-hide w-nav-link">Logout</a></span>
                        <router-link   @click.native="closeMenu(false)" v-bind:to="'/contact-us'" class="nav-link nav-hide w-nav-link">Contact Us</router-link>
                    </nav>
                    <div class="menu-button w-nav-button"
                    v-on:click="toggleMobileMenu"
                    v-bind:class="openClass"></div>
                    <span v-if="loggedIn" style="margin-left: auto;"><router-link v-bind:to="'/my-posts'" class="nav-link nav-hide-1 w-nav-link">Manage Posts</router-link></span>
                    <router-link v-bind:to="'/login'" v-if="!loggedIn" class="nav-link nav-hide-1 w-nav-link">Login / Register</router-link>
                    <span  v-if="loggedIn"><a v-on:click="logout()" class="nav-link nav-hide-1 w-nav-link">Logout</a></span>
                </div>
                <div id="w-node-96d1b8820698-62e76204" class="div-block-3"></div><router-link v-bind:to="'/cnpm installontact-us'" class="nav-link nav-hide-1 w-nav-link">Contact Us</router-link></div>
        </div>
    </div>
</template>

<script>
    import {userService} from "../assets/js/services/userService";

    export default {
        name: "NavHeader",
        data() {
            return {
                loggedIn : false,
                userName : '',
                isMobileMenuOpen: false,
                openClass: ''
            }
        },
        created () {
            let user = JSON.parse(localStorage.getItem('user'));
            if (user){
                this.loggedIn = true;
                this.userName =  user.firstName + " " + user.lastName;
            }
        },
        methods: {
            logout () {
                userService.logout(true);
                this.loggedIn = false;
                this.user = null;
            },
            toggleMobileMenu: function(){
                if (this.isMobileMenuOpen) {
                    this.openClass = '';
                    this.$refs['mobileNav'].removeAttribute('data-nav-menu-open');
                }
                else {
                    this.openClass = 'w--open';
                    this.$refs['mobileNav'].setAttribute('data-nav-menu-open', '');
                }
                this.isMobileMenuOpen = !this.isMobileMenuOpen;
            },
            closeMenu(logout){
                if (this.isMobileMenuOpen) {
                    this.openClass = '';
                    this.$refs['mobileNav'].removeAttribute('data-nav-menu-open');
                    this.isMobileMenuOpen = !this.isMobileMenuOpen;
                }

                if (logout){
                    this.logout();
                }
            }
        },
        mounted: function () {
            this.$root.$on('loginLogoutEvent', (user) => { // here you need to use the arrow function
                if (user) {
                    this.loggedIn = true;
                    this.userName = user.firstName + " " + user.lastName;
                } else{
                    this.loggedIn = false;
                    this.user = null;
                }
            })
        }
    }
</script>

<style scoped>
.username {
    padding: 0px;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-weight: 500;
    text-align: left;
    text-transform: none;
    color: #222222;
}
</style>
